/**
 * Returns the current window scroll position.
 */
export const getWindowScrollPosition = () => {
    return {
        x: window.pageXOffset || document.documentElement.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop
    };
};
/**
 * Returns a window point relative to an HTMLElement.
 */
export const getRelativePoint = (windowPoint, element) => {
    const windowScrollPosition = getWindowScrollPosition();
    const elementRect = element.getBoundingClientRect();
    return {
        x: windowPoint.x + windowScrollPosition.x - elementRect.left,
        y: windowPoint.y - windowScrollPosition.y - elementRect.top
    };
};
